import VideoJsAdapter from "../../adapters/videojs_adapter";

import Button from "../button";

export default class Index extends Button {

  buildCSSClass() {
    return 'vjs-big-pause-button vjs-big-button';
  }

  handleClick(){
    if(this.player().paused()) {
      this.player().play();
    } else {
      this.player().pause();
    }
  }
}

VideoJsAdapter.registerComponent('VpBigPauseButton', Index);
